import { render, staticRenderFns } from "./IconAngryFace.vue?vue&type=template&id=189e6c32&"
import script from "./IconAngryFace.vue?vue&type=script&lang=js&"
export * from "./IconAngryFace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports